/* eslint-disable react/react-in-jsx-scope */
import { del } from 'helpers/api_helper';
import './ModalCompanys.css';

const ModalDeleteCompany = ({ companyId, urlTo, setIsModalOpen, setCurrentPage }) => {

  const handleDeleteCompany = async () => {
    const url = `${process.env.REACT_APP_API_INT_LEADS}/api/empresas-${urlTo}/${companyId}`;
      
    try {
      await del(url);
      setIsModalOpen(false);
      setCurrentPage(1);
      return;
    } catch (error) {
      console.log(error);
      alert("Algo de errado aconteceu! Tente mais tarde ou verifique sua internet!");
      return;
    }
  }

  return (
    <div className='companys-modal-container'>
      <div className='modal-inner-container'>
        <span className='span-title-atention'>ATENÇÃO</span>
        <span className='span-company-text'>
          Você tem certeza que deseja<br/> 
          tirar esta empresa da lista?
        </span>
        <div className='buttons-actions-row'>
          <button 
            className='btn btn-primary w-md button-company-modal'
            onClick={() => setIsModalOpen(false)}
            type='button'
          >
            Cancelar
          </button>
          <button 
            type='button'
            className='btn btn-primary w-md button-company-modal'
            onClick={handleDeleteCompany}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  )
}

export default ModalDeleteCompany